interface TranscriptMetricsProps {
  workloadUsed: number
  totalWorkload: number
  coursesUsed: number
  totalCourses: number
}

export function TranscriptMetrics({
  coursesUsed,
  totalCourses,
  totalWorkload,
  workloadUsed
}: TranscriptMetricsProps) {
  return (
    <div>
      <p className="font-medium">
        Carga horária aproveitada: {workloadUsed.toLocaleString('pt-BR')}h de{' '}
        {totalWorkload.toLocaleString('pt-BR')}h
      </p>
      <p className="font-medium mt-2">
        Disciplinas aproveitadas: {coursesUsed} de {totalCourses}
      </p>
    </div>
  )
}
